var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fail_status_24",
    transform: "translate(8169 4382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24573",
    "data-name": "Rechteck 24573",
    width: 16,
    height: 16,
    transform: "translate(-8169 -4382)",
    fill: "rgba(102,102,102,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5561",
    "data-name": "Pfad 5561",
    d: "M8,1.08105a6.95948,6.95948,0,1,0,6.95947,6.95948A6.95952,6.95952,0,0,0,8,1.08105Zm2.397,9.971L7.958,8.613,5.603,10.969l-.637-.637L7.322,7.977,5.094,5.749l.636-.637L7.958,7.34l2.311-2.311.637.637L8.595,7.977l2.439,2.438Z",
    transform: "translate(-8169 -4382)",
    fill: "#d50000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError16);
export default __webpack_public_path__ + "static/media/Error_16.69f12dae133eb665076bfadbac912dc0.svg";
export { ForwardRef as ReactComponent };